const ENV_BACKEND_URL = process.env.REACT_APP_BACKEND_URL?.trim();
const WINDOW_ORIGIN = typeof window !== "undefined" ? window.location.origin : "";
const IS_BROWSER = typeof window !== "undefined";
const IS_PLACEHOLDER_URL = !!ENV_BACKEND_URL && /yourdomain\.com/i.test(ENV_BACKEND_URL);
const IS_LOCALHOST_ENV =
  !!ENV_BACKEND_URL && /localhost|127\.0\.0\.1/i.test(ENV_BACKEND_URL);
const IS_LOCALHOST_HOSTNAME =
  IS_BROWSER && /^(localhost|127\.0\.0\.1)$/i.test(window.location.hostname);

const shouldUseEnvBackend =
  !!ENV_BACKEND_URL &&
  !IS_PLACEHOLDER_URL &&
  !(IS_LOCALHOST_ENV && !IS_LOCALHOST_HOSTNAME);

export const BACKEND_URL = shouldUseEnvBackend
  ? ENV_BACKEND_URL.replace(/\/$/, "")
  : (WINDOW_ORIGIN || "http://localhost:8000");

export const API = `${BACKEND_URL}/api`;

export const PHP_API = {
  authLogin: `${API}/auth/login.php`,
  authMe: `${API}/auth/me.php`,
  users: `${API}/users.php`,
  categories: `${API}/categories.php`,
  category: `${API}/category.php`,
  products: `${API}/products.php`,
  product: `${API}/product.php`,
  upload: `${API}/upload.php`,
  inquiries: `${API}/inquiries.php`,
  inquiry: `${API}/inquiry.php`,
  inquiryStatus: `${API}/inquiry-status.php`,
  contacts: `${API}/contacts.php`,
  contact: `${API}/contact.php`,
  contactStatus: `${API}/contact-status.php`,
  dashboardStats: `${API}/dashboard-stats.php`,
  health: `${API}/health.php`,
};
